import React, { useEffect, useRef, useState } from "react";
import Picture from "../assets/Picture.png";
import line from "../assets/line.png";
import Integrated from "../assets/Integrated.png";
import First from "../assets/First.jpg";
import { motion } from 'framer-motion';
import Innovation from "./Innovation";
import About1 from "../assets/About1.png";
import About2 from "../assets/About2.png";
import About3 from "../assets/About3.png";
import WiseFrameworkWithLines from "./WiseFrameworkWithLines";
import Features from "./Features";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
const WiseUX = () => {
  return (
    <div className="min-h-screen scroll-smooth">
      
<section className="relative h-[60vh] flex items-center justify-center text-white overflow-hidden">
  {/* 🔁 Background Video */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    src="/AboutUs780.mp4"
    autoPlay
    muted
    loop
    playsInline
  />

  {/* 🌫️ Transparent Overlay */}
<div className="absolute inset-0  bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

  {/* 👉 Change bg-black/50 to bg-purple-300/40 if you want purple tint */}

  {/* 📦 Foreground Content */}
  <div className="relative z-20 max-w-7xl mx-auto px-6 w-full h-full flex items-center justify-center">
    <div className="text-center">
      <motion.h1
        className="text-5xl md:text-7xl text-white font-bold"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        DISCOVER WISSENSTIL
      </motion.h1>

      <motion.h2
        className="font-extrabold text-transparent"
        style={{
          fontFamily: "Calibri, sans-serif",
          WebkitTextStroke: "2px #ffffff",
          fontSize: "4rem",
          letterSpacing: "0.05em",
          lineHeight: "1",
          whiteSpace: "nowrap",
        }}
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      >
        AI DRIVEN INNOVATOR
      </motion.h2>
    </div>
  </div>
</section>


      {/* Vision Section */}
<section className="pt-[100px] pb-12 px-6 bg-white flex flex-col items-center justify-center text-center md:text-left snap-start w-full h-auto">
  <div className="max-w-6xl w-full mx-auto flex flex-col items-center text-gray-900 text-lg md:text-2xl font-normal leading-tight space-y-10 text-center">
    
   {/* Paragraph */}
<p
  className="mt-6 max-w-3xl text-gray-700 leading-relaxed mx-auto text-base sm:text-lg md:text-xl text-center"
  style={{ fontFamily: "Calibri, sans-serif" }}
>
  Driven by a team of AI specialists, engineers, and domain experts, we develop
  solutions that integrate seamlessly into <b>healthcare, life sciences, aerospace, and beyond</b>. 
  Our goal is to bridge the gap between complex AI models and real-world applications, 
  ensuring smarter decision-making and streamlined operations.
</p>

    {/* OUR VISION Block */}
    <div className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0 md:space-x-8 text-center">
      
      {/* OUR VISION heading */}
      <div>
        <h1
          className="font-extrabold text-transparent"
          style={{
            fontFamily: "Calibri, sans-serif",
            WebkitTextStroke: "2px #9c6bff",
            fontSize: "5.5rem",
            letterSpacing: "0.05em",
            lineHeight: "1",
          }}
        >
          OUR <br /> VISION
        </h1>
      </div>

      {/* Description */}
      <div className="max-w-xl">
      <p
  className="mt-6 max-w-3xl text-gray-700 leading-relaxed mx-auto text-base sm:text-lg md:text-xl text-center"
  style={{ fontFamily: "Calibri, sans-serif" }}
>
  To pioneer AI-driven innovation that transforms industries, 
  enhances decision-making, and empowers businesses with 
  intelligent, scalable, and future-ready solutions.
</p>

      </div>
    </div>
    
  </div>
</section>

<section className="pt-[100px]  bg-gradient-to-r  bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white py-16 min-h-screen flex flex-col items-center snap-start h-screen w-full">
  <div className="max-w-6xl w-full mx-auto px-0">  {/* Remove horizontal padding here */}
    {/* Heading above the image */}
   <h2 className="ml-[115px] text-white text-3xl font-semibold">
  The <span className="text-blue-300">Minds</span> Behind Wissenstil
  <img src={line} alt="line" className="h-50 w-auto" />
</h2>
    </div>
</section>
<section id="innovation" className="bg-white py-10">
  <Innovation />
</section>


<section className="w-screen snap-start bg-gradient-to-r  bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden flex items-center justify-center h-auto py-20">
  <WiseFrameworkWithLines />
</section>

<section className="w-screen snap-start bg-gradient-to-r from-[#ffffff] to-[#fffff] text-black relative overflow-hidden flex items-center justify-center h-auto py-20">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-28 px-4">
    
    {/* Image */}
    <motion.img
      src={About2}
      alt=""
      className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-sm h-auto z-10"
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    />

    {/* Text Content */}
    <div className="max-w-xl">
      <p className="font-calibri text-gray-800 text-sm md:text-base leading-relaxed">
        WISE streamlines the process of <strong>image annotation and data labeling</strong>, reducing manual effort while accelerating AI model training. By learning from minimal user input, WISE <strong>auto-annotates images</strong>, making neural network training more efficient and scalable.
        <br /><br />
        At its core, WISE is a <strong>sophisticated collection of machine learning algorithms and optimized neural networks</strong>. This enables what we call <strong>"zero prototyping"</strong>, allowing AI experts to focus on solving complex challenges instead of spending time on exploratory tasks like selecting the right algorithm or network.
      </p>
    </div>
  </div>
</section>

<section className="w-screen snap-start bg-gradient-to-r from-[#ffffff] to-[#fffff] text-black relative overflow-hidden flex items-center justify-center h-auto py-20">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-10 md:gap-20 px-4">
    
    {/* Text Left */}
    <div className="max-w-xl text-center md:text-left">
      <p className="font-calibri text-gray-800 text-sm md:text-base leading-relaxed">
        But WISE goes beyond deep learning. The framework integrates
        <strong> computer vision, traditional machine learning approaches, and natural language processing (NLP)</strong>
        to ensure that the most suitable technology is applied to each unique problem. This results in
        <strong> higher accuracy, adaptability, and efficiency</strong>.
        <br /><br />
        With its <strong>carefully orchestrated AI technologies</strong>, WISE powers solutions in
        <strong> image analysis, predictive modeling, anomaly detection, classification, and beyond</strong>—
        delivering intelligent automation that transforms industries.
      </p>
    </div>

    {/* Image Right */}
    <motion.img
      src={About3}
      alt=""
      className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-sm h-auto"
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    />
  </div>
</section>
<section className="w-full  bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden flex items-center justify-center py-10">
  <Features />
</section>
<section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden">
  {/* White curved part */}
  <div className="absolute top-[180px] left-0 w-full">
    <div className="bg-white rounded-t-[12rem] sm:rounded-t-[14rem] h-[120vh]"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
    {/* Top heading part */}
    <div className="text-center mt-[160px] mb-12">
      <h2
  className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]"
>
  Collaborate for Success
</h2>
      <p className="text-gray-700 text-lg sm:text-xl font-medium">
        Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
      </p>
    </div>

    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>

      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>

{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>

      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     

<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>


</div>
  );
};

export default WiseUX;
